export const IFRAME_CROSS_DOMAIN_PERMISSIONS = [
	'clipboard-write',
	'autoplay',
	'camera',
	'microphone',
	'geolocation',
	'vr',
].join(';')
